import { render, staticRenderFns } from "./InProcessingEmailComponent.vue?vue&type=template&id=66a0759c&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66a0759c')) {
      api.createRecord('66a0759c', component.options)
    } else {
      api.reload('66a0759c', component.options)
    }
    module.hot.accept("./InProcessingEmailComponent.vue?vue&type=template&id=66a0759c&", function () {
      api.rerender('66a0759c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Email/InProcessingEmailComponent.vue"
export default component.exports